import { createContext, useContext } from 'react';

/**
 * @typedef AboutusContextState
 * @property {boolean} isLoading
 * @property {string} about
 * @property {string} bookGuideline
 * @property {string} importantReminder
 * @property {string} travelFeePolicy
 */

/** @type {AboutusContextState} */
const initialState = {
    isLoading: false,
    about: '',
    bookGuideline: '',
    importantReminder: '',
    travelFeePolicy: '',
};

const AboutUsContext = createContext(initialState);

export const useAboutUsCtx = () => useContext(AboutUsContext);

export default AboutUsContext;
